<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright">
        &copy; 2019 - {{ year }}, Feito com <i class="tim-icons icon-heart-2"></i> por
        <a href="https://www.7cliques.com.br/" target="_blank">7 Cliques</a>
        Desenvolvimento Web e Aplicativos
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style></style>
